import CandidateSearchList, { CandidateSearchListProps } from './CandidateSearchList.component';

export type CandidateSearchListType = CandidateSearchListProps;

export default CandidateSearchList;
